import {Alert, Typography} from "@material-tailwind/react";
import React from "react";

export function AgentServiceHeaderAlert() {
  return (
    <Alert className="w-full px-0" variant="gradient">
      <Typography variant="h5" className="mb-4">
        مشاور گرامی؛
      </Typography>
      <Typography variant="body" color="">
        <li>
          از طریق دکمه مشاهده/بررسی مدارک می توانید با کاربر ارتباط(تماس تلفنی و نقل و انتقال
          مدارک و مستندات) بگیرید.
        </li>
      </Typography>
      <Typography variant="body" color="">
        <li>
          طبق قوانین پلتفرم مباشر، پس از پرداخت، بایستی مرحله به مرحله از طریق دکمه گزارش
          پیشرفت مراحل خدمت را به کاربر اطلاع رسانی نمائید.
        </li>
      </Typography>
      <Typography variant="body" color="">
        <li>
          بدیهی است در صورت عدم تامین مدارک و مستندات لازم از سوی کاربر، هرگونه تاخیر و
          تبعات بر عهده کاربر خواهد بود.
        </li>
      </Typography>
    </Alert>
  )
}
